import { Divider, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import type { Dispatch, SetStateAction } from 'react';

import Button from '@/contents/General/Button';
import Stack from '@/contents/General/Stack';
import Typography from '@/contents/General/Typography';
import theme from '@/styles/theme';
import type { ContactFromInput } from '@/types/main';

import Icon from '../General/Icon';

const Container = styled(Box)<{ is_pc: string }>`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 ${theme.spacing(3)};
  min-height: 100vh;
  background: #f4f8f6;
  ${(props) => props.is_pc && `max-width: 506px;`}
  main {
    max-width: inherit;
    z-index: 1;
  }
`;

const ContactConfirmPage = (props: {
  input: ContactFromInput;
  onSubmit: () => void;
  setPage: Dispatch<SetStateAction<'input' | 'confirm'>>;
}) => {
  const isPC = useMediaQuery('(min-width:900px)');

  return (
    <>
      <Container is_pc={isPC ? isPC.toString() : ''}>
        <Stack center paddingTop={5} paddingBottom={4}>
          <Typography fontSize={21} fontWeight={700}>
            お問い合わせ
          </Typography>
        </Stack>
        <Stack column space={3} paddingBottom={7}>
          <Box>
            <Typography fontSize={14} fontWeight={500} paddingBottom={2}>
              タイトル・カテゴリ
            </Typography>
            <Typography fontSize={16} fontWeight={700}>
              キャンプ場の情報・写真登録
            </Typography>
          </Box>
          <Divider />
          <Box>
            <Typography fontSize={14} fontWeight={500} paddingBottom={2}>
              メールアドレス
            </Typography>
            <Typography fontSize={16} fontWeight={700}>
              {props.input.email}
            </Typography>
          </Box>
          <Divider />
          <Box>
            <Typography fontSize={14} fontWeight={500} paddingBottom={2}>
              お名前
            </Typography>
            <Typography fontSize={16} fontWeight={700}>
              {props.input.name}
            </Typography>
          </Box>
          <Divider />
          <Box>
            <Typography fontSize={14} fontWeight={500} paddingBottom={2}>
              お問い合わせ内容
            </Typography>
            <Typography fontSize={16} fontWeight={700}>
              {props.input.content}
            </Typography>
          </Box>
          <Divider />
          <Box>
            <Typography fontSize={14} fontWeight={500} paddingBottom={2}>
              添付ファイル
            </Typography>
            <Typography fontSize={16} fontWeight={700}>
              {(props.input.file ?? []).length > 0
                ? // @ts-ignore
                  props.input.file[0].name
                : '添付ファイルなし'}
            </Typography>
          </Box>
        </Stack>
        <Stack column center space={4}>
          <Button
            onClick={() => {
              props.onSubmit();
            }}
            buttonSize="md"
            sx={{ width: '289px' }}
          >
            送信する
          </Button>
        </Stack>
        <Stack center paddingTop={4} onClick={() => props.setPage('input')}>
          <Icon iconType="arrow-right" color="primary" />
          <Typography fontSize={14} color="primary" fontWeight={700}>
            入力画面に戻る
          </Typography>
        </Stack>
      </Container>
    </>
  );
};

export default ContactConfirmPage;
